<template>
  <v-navigation-drawer app clipped v-model="DRAWER_STATE" :mini-variant="!DRAWER_STATE" :width="sidebarWidth"
    :permanent="$vuetify.breakpoint.lgAndUp" :mini-variant-width="sidebarMinWidth"
    :class="{ 'drawer-mini': !DRAWER_STATE }">
    <v-list>
      <template v-for="(item, i) in items">
        <v-row v-if="item.heading" :key="item.heading" align="center">
          <v-col cols="6">
            <span style="padding-left: 32px" class="text-body-1 subheader"
              :class="(item.heading && DRAWER_STATE) ? 'show ' : 'hide'">
              {{ item.heading }}
            </span>
          </v-col>
          <v-col cols="6" class="text-center">
          </v-col>
        </v-row>
        <v-divider v-else-if="item.divider" :key="i" dark class="my-4"></v-divider>
        <v-list-group color="primary" v-else-if="item.children && DRAWER_STATE" :key="item.title" v-model="item.model">

          <template v-slot:prependIcon>
            <v-icon size="24" class="mr-0" color="greyTint"> {{ item.icon }} </v-icon>
          </template>
          <template v-slot:activator>
            <v-list-item-content>
              <v-badge v-if="item.badge" content="New" color="secondary">
              </v-badge>
              <v-list-item-title>
                {{ item.title }}
              </v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item v-show="!item.type" v-for="(child, i) in item.children" :key="i" :to="child.link" link
            class="pl-12" @click="child.action ? child.action() : null">
            <v-list-item-action class="mr-2" v-if="child.icon">
              <v-icon size="">{{ child.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ child.title }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <template v-if="item.type">
            <v-list-group v-for="(item, i) in item.children" :key="i" :value="true" no-action sub-group>
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item-content>
              </template>

              <v-list-item v-for="(child, i) in item.children" :key="i" link>
                <v-list-item-title v-text="child.title"></v-list-item-title>
              </v-list-item>
            </v-list-group>
          </template>
        </v-list-group>
        <v-list-item color="primary" v-else :key="item.text" :href="item.href ? item.href : null"
          :to="item.link === '#' ? '' : item.link" @click="item.action ? item.action() : null" link>
          <v-list-item-action class="mr-6">
            <v-icon :size="item.size ? item.size : 24" :color="item.color ? item.color : 'greyTint'">{{ item.icon
            }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title link>
              {{ item.title }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>

  </v-navigation-drawer>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Inicio from '@/services/main/main.service.js';

export default {
  props: {
    source: String,
  },
  data() {
    return {
      items: [
        { title: 'Inicio', icon: 'mdi-vector-circle-variant', link: { name: 'index' } },
        { title: 'Búsqueda Avanzada', icon: 'mdi-magnify', link: { name: 'BusquedaAvanzada' } },
      ],
      sidebarWidth: 240,
      sidebarMinWidth: 90,
    }
  },
  computed: {
    ...mapState({ drawer: state => state.drawer }),
    DRAWER_STATE: {
      get() {
        return this.drawer
      },
      set(newValue) {
        if (newValue === this.drawer) return;
        this.TOGGLE_DRAWER();
      }
    },
    ...mapState([
      "domain",
      "informationPage",
      "paginacion",
      "permission",
      "user"
    ])
  },
  methods: {
    ...mapActions(['TOGGLE_DRAWER']),
    logOut: function () {
      window.localStorage.setItem('authenticated', false);
      window.localStorage.removeItem('token');
      this.$router.push('/login');
    },
    ObtenerPermisos(permiso) {
      Inicio.VerificarPermisos(this, permiso).then(response => {
        if (response.length > 0) {
          switch (permiso) {
            case 321:
              this.items.push({ title: 'Estadisticas', icon: 'mdi mdi-chart-bar', link: { name: 'estadisticas' }, orden: 1 });
              break;
            case 327:
              this.items.push({ title: 'Bitacora', icon: 'mdi mdi-table-clock', link: { name: 'bitacora' }, orden: 2 });
              break;
            case 355:
              this.items.push({ title: 'Viales', icon: 'mdi mdi-car-hatchback', link: { name: 'Viales' }, orden: 3 });
              break;
            case 344:
              this.items.push({ title: 'Configuración', icon: 'mdi mdi-cog', link: { name: 'configuracion' }, orden: 4 });
              break;
          }
        }
        // Ordenar los elementos en base a la propiedad "orden"
        this.items.sort((a, b) => a.orden - b.orden);
      });
    }
  },
  mounted() {
    const esperar1Seg = () => new Promise(resolve => setTimeout(resolve, 1000));
    esperar1Seg()
      .then(() => {
        this.ObtenerPermisos(this.permission.single.estadistico);
      })
      .then(() => {
        this.ObtenerPermisos(this.permission.single.bitacora);
      })
      .then(() => {
        this.ObtenerPermisos(this.permission.single.viales);
      })
      .then(() => {
        this.ObtenerPermisos(this.permission.single.configuracion);
      });
  }
}
</script>

<style src="@/views/shared/sidebar/Sidebar.scss" lang="scss"/>
